import { Injectable } from "@angular/core";
import { createEffect, Actions, ofType, Effect } from "@ngrx/effects";
import { NotificationService } from "@cradua/core";
import {
  map,
  catchError,
  concatMap,
  exhaustMap,
  switchMap,
  mergeMap,
  takeUntil,
   withLatestFrom, filter, tap
} from "rxjs/operators";
import { of, Observable } from "rxjs";
import * as GenericActions from "./acquisition-generic.actions";
import { AcquisitionGenericService } from "../../services/acquisition-generic.service";
import { Action, Store } from "@ngrx/store";
import { AcquisitionGenericStoreReducer, AcquisitionGenericStoreSelectors } from './index';

@Injectable()
export class AcquisitionGenericEffects {
  mainActionType: string;

  // loadLandParcel$ = createEffect(() =>
  //   this.loadAllData(GenericActions, "LandParcel")
  // );

  // clearLandParcel$ = createEffect(() =>
  //   this.loadClearState(GenericActions, "LandParcel")
  // );
  // addLandParcel$ = createEffect(() => this.add(GenericActions, "LandParcel"));

  // updateLandParcel$ = createEffect(() =>
  //   this.update(GenericActions, "LandParcel")
  // );

  // deleteLandParcel$ = createEffect(() =>
  //   this.remove(GenericActions, "LandParcel")
  // );

  loadAddressBookIncident$ = createEffect(() =>
    this.incidentLoadAllData(GenericActions, "AddressBook")
  );

  loadAddressBookIncidentWithoutId$ = createEffect(() =>
  this.incidentLoadAllDataWithoutId(GenericActions, "AddressBook")
);

  clearAddressBookIncident$ = createEffect(() =>
  this.incidentLoadClearState(GenericActions, "AddressBook")
);

  loadAddressBookIncidentById$ = createEffect(() =>
  this.incidentLoadAllDataById(GenericActions, "AddressBook")
);

  addAddressBookIncident$ = createEffect(() => this.incidentAdd(GenericActions, "AddressBook"));

  updateAddressBookIncident$ = createEffect(() =>
    this.incidentUpdate(GenericActions, "AddressBook")
  );

  deleteAddressBookIncident$ = createEffect(() =>
    this.incidentRemove(GenericActions, "AddressBook")
  );

  // loadLessorInfo$ = createEffect(() =>
  //   this.loadAllData(GenericActions, "LessorInfo")
  // );

  // loadLessorInfoById$ = createEffect(() =>
  //   this.loadAllDataById(GenericActions, "LessorInfo")
  // );
  // addLessorInfo$ = createEffect(() => this.add(GenericActions, "LessorInfo"));

  // updateLessorInfo$ = createEffect(() =>
  //   this.update(GenericActions, "LessorInfo")
  // );

  // deleteLessorInfo$ = createEffect(() =>
  //   this.remove(GenericActions, "LessorInfo")
  // );


  // loadLessorAreaMaker$ = createEffect(() =>
  //   this.loadAllData(GenericActions, "LessorAreaMaker")
  // );

  // loadLessorAreaMakerById$ = createEffect(() =>
  //   this.loadAllDataById(GenericActions, "LessorAreaMaker")
  // );
  // addLessorAreaMaker$ = createEffect(() => this.add(GenericActions, "LessorAreaMaker"));

  // updateLessorAreaMaker$ = createEffect(() =>
  //   this.update(GenericActions, "LessorAreaMaker")
  // );

  // deleteLessorAreaMaker$ = createEffect(() =>
  //   this.remove(GenericActions, "LessorAreaMaker")
  // );


  // loadLessorRepresentative$ = createEffect(() =>
  //   this.loadAllData(GenericActions, "LessorRepresentative")
  // );

  // loadLessorRepresentativeById$ = createEffect(() =>
  //   this.loadAllDataById(GenericActions, "LessorRepresentative")
  // );
  // addLessorRepresentative$ = createEffect(() => this.add(GenericActions, "LessorRepresentative"));

  // updateLessorRepresentative$ = createEffect(() =>
  //   this.update(GenericActions, "LessorRepresentative")
  // );

  // deleteLessorRepresentative$ = createEffect(() =>
  //   this.remove(GenericActions, "LessorRepresentative")
  // );


  // loadIndividualAcreages$ = createEffect(() =>
  //   this.loadAllData(GenericActions, "IndividualAcreages")
  // );

  // loadIndividualAcreagesById$ = createEffect(() =>
  //   this.loadAllDataById(GenericActions, "IndividualAcreages")
  // );
  // addIndividualAcreages$ = createEffect(() => this.add(GenericActions, "IndividualAcreages"));

  // updateIndividualAcreages$ = createEffect(() =>
  //   this.update(GenericActions, "IndividualAcreages")
  // );

  // deleteIndividualAcreages$ = createEffect(() =>
  //   this.remove(GenericActions, "IndividualAcreages")
  // );


  // loadAssetLocation$ = createEffect(() =>
  //   this.loadAllData(GenericActions, "AssetLocation")
  // );

  // loadAssetLocationById$ = createEffect(() =>
  //   this.loadAllDataById(GenericActions, "AssetLocation")
  // );
  // addAssetLocation$ = createEffect(() => this.add(GenericActions, "AssetLocation"));

  // updateAssetLocation$ = createEffect(() =>
  //   this.update(GenericActions, "AssetLocation")
  // );

  // deleteAssetLocation$ = createEffect(() =>
  //   this.remove(GenericActions, "AssetLocation")
  // );

  // loadCreatedUser$ = createEffect(() =>
  //   this.loadAllData(GenericActions, "CreatedUser")
  // );

  // loadCreatedUserById$ = createEffect(() =>
  //   this.loadAllDataById(GenericActions, "CreatedUser")
  // );
  // addCreatedUser$ = createEffect(() => this.add(GenericActions, "CreatedUser"));

  // updateCreatedUser$ = createEffect(() =>
  //   this.update(GenericActions, "CreatedUser")
  // );

  // deleteCreatedUser$ = createEffect(() =>
  //   this.remove(GenericActions, "CreatedUser")
  // );
  // loadModifyUser$ = createEffect(() =>
  //   this.loadAllData(GenericActions, "ModifyUser")
  // );

  // loadModifyUserById$ = createEffect(() =>
  //   this.loadAllDataById(GenericActions, "ModifyUser")
  // );
  // addModifyUser$ = createEffect(() => this.add(GenericActions, "ModifyUser"));

  // updateModifyUser$ = createEffect(() =>
  //   this.update(GenericActions, "ModifyUser")
  // );

  // deleteModifyUser$ = createEffect(() =>
  //   this.remove(GenericActions, "ModifyUser")
  // );

  public SetActionType(type: string) {
    this.mainActionType = type;
  }

  protected incidentLoadClearState(actions, type) {
    const fn: Observable<Action> = this.actions$.pipe(
      ofType(actions.loadIncidenceGenericClearState(type)),
      mergeMap((action) => of(actions.loadIncidenceGenericClearStateSuccess(type)({ returnedData: [] }))));
    return fn;



  }

  protected incidentLoadAllData(actions, type) {

    const fn: Observable<Action> = this.actions$.pipe(
        ofType(actions.loadIncidenceGeneric(type)),
        concatMap((action) =>
          of(action).pipe(
            withLatestFrom(this.store.select(AcquisitionGenericStoreSelectors.getAllGeneric(action.modelType))),
          ),
        ),
        // tap(([action, data]) => console.log('data from effect ', action, data)),

        switchMap(([action, entities]) => {

          if(entities.length && entities[0].LandTitleId === action.id && action.id !== '') {
           return of(actions.loadIncidenceGenericSuccess(type)({ returnedData: entities }));
          }
          return  this.acquisitionGenericService.getAll(type, action.id).pipe(
            map((data) => {
              return actions.loadIncidenceGenericSuccess(type)({ returnedData: data });
            }),
            catchError((error) => of(actions.loadIncidenceGenericFailure(type)({ error }))),
          )
        }),
      )
      return fn;
    }


    protected incidentLoadAllDataWithoutId(actions, type) {

      const fn: Observable<Action> = this.actions$.pipe(
          ofType(actions.loadIncidenceGenericWithoutId(type)),
          concatMap((action) =>
            of(action).pipe(
              withLatestFrom(this.store.select(AcquisitionGenericStoreSelectors.getAllGeneric(action.modelType))),
            ),
          ),
          // tap(([action, data]) => console.log('data from effect ', action, data)),

          switchMap(([action, entities]) => {
            if(entities && entities.length) {
              // console.log('data from effect ', action, entities)
             return of(actions.loadIncidenceGenericWithoutIdSuccess(type)({ returnedData: entities }));
            }
            return  this.acquisitionGenericService.getAllWithoutId(type).pipe(
              map((data) => {
                return actions.loadIncidenceGenericWithoutIdSuccess(type)({ returnedData: data });
              }),
              catchError((error) => of(actions.loadIncidenceGenericWithoutIdFailure(type)({ error }))),
            )
          }),
        )
        return fn;
      }

    protected incidentLoadAllDataById(actions, type) {

      const fn: Observable<Action> = this.actions$.pipe(
          ofType(actions.loadIncidenceByIdGeneric(type)),
          concatMap((action) =>
            of(action).pipe(
              withLatestFrom(this.store.select(AcquisitionGenericStoreSelectors.getAllGeneric(action.modelType))),
            ),
          ),
          // tap(([action, data]) => console.log('data from effect ', action, data)),

          switchMap(([action, entities]) => {
            if(entities.length && entities[0].LandTitleId === action.id && action.id !== '') {
             return of(actions.loadIncidenceByIdGenericSuccess(type)({ returnedData: entities }));
            }
            return  this.acquisitionGenericService.getAllById(type, action.id).pipe(
              map((data) => {
                return actions.loadIncidenceByIdGenericSuccess(type)({ returnedData: data });
              }),
              catchError((error) => of(actions.loadIncidenceByIdGenericFailure(type)({ error }))),
            )
          }),
        )
        return fn;
      }

  protected incidentAdd(actions, type) {
    const fn: Observable<Action> = this.actions$.pipe(
      ofType(actions.addIncidenceGeneric(type)),
      concatMap(({ dataToAdd }) =>
        this.acquisitionGenericService
          .createData(type, dataToAdd)
          .pipe(
            map((data) => {
              this.notification.success("Saved Successfully");
              return actions.addIncidenceGenericSuccess(type)({ returnedData: data })
            }

            ),
            catchError((error) =>
              of(
                actions.addIncidenceGenericFailure(type)({ error: error.error.message }),
              )
            ),
          )
      ),
    );
    return fn;
  }
  protected incidentUpdate(actions, type) {
    const fn: Observable<Action> = this.actions$.pipe(
      ofType(actions.updateIncidenceGeneric(type)),
      concatMap(({ dataToAdd, deletedData }) =>
        this.acquisitionGenericService
          .updateData(type, dataToAdd, deletedData)
          .pipe(
            map((data) => {
              this.notification.success("Updated Successfully");
              return actions.updateIncidenceGenericSuccess(type)({ returnedData: data })
            }),
            catchError((error) =>
              of(
                actions.updateIncidenceGenericFailure(type)(
                  { error: error.error.message },
                ),
              )
            ),
          )
      ),
    );
    return fn;
  }
  protected incidentRemove(actions, type) {
    const fn: Observable<Action> = this.actions$.pipe(
      ofType(actions.removeIncidenceGeneric(type)),
      concatMap(({ ids }) =>
        this.acquisitionGenericService
          .deleteData(type, ids)
          .pipe(
            map((data) => {
              this.notification.success("Deleted Successfully");
              return actions.removeIncidenceGenericSuccess(type)({ ids })
            }),
            catchError((error) =>
              of(
                actions.removeIncidenceGenericFailure(type)(
                  { error: error.error.message },
                ),
              )
            ),
          )
      ),
    );
    return fn;
  } // loadGenericBank$ = createEffect(() =>
  // this.loadAllData(GenericActions,"Bank")
  // );
  // addGenericBank$ = createEffect(() =>
  // 	  this.add(GenericActions,"Bank")
  // );
  // updateGenericBank$ = createEffect(() =>
  // 	  this.update(GenericActions,"Bank")
  // );
  // deleteGenericBank$ = createEffect(() =>
  // 	  this.remove(GenericActions,"Bank")
  // );

  constructor(
    private actions$: Actions,
    private acquisitionGenericService: AcquisitionGenericService,
    private store: Store<AcquisitionGenericStoreReducer.GenericPartialState>,
    private notification: NotificationService,
  ) {}
}
